/*
 *  Responsive Settings
 *    Settings that match the SCSS responsive settings
 *
 *
 *  Version:
 *    1.0.1 - 2019/12/01
 */
export const xsmall = 350;
export const small = 750;
export const medium = 1100;
export const large = 1350;
export const xlarge = 1650;
export const xxlarge = 2000;
